import React, { useEffect, useState } from "react";
import { emergencyContactType } from "../../../../common/interfaces/myProfile/personalDetails/emergencyContactType";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setEmergencyContactInfo: (data: emergencyContactType) => void;
}

function DTOEmergencyContact({ setEmergencyContactInfo }: PropsValues) {
  const selector = useAppSelector((state) => state.emergencyContactSlice);

  useEffect(() => {
    const emergency_contact_data: emergencyContactType = {
      emergencyContactNumber: selector.emergencyContactNumber,
      emergencyPersonName: selector.emergencyPersonName,
      emergencyCountry: selector.emergencyCountry,
      emergencyEmail: selector.emergencyEmail,
      emergencyRelationship: selector.emergencyRelationship,
    };
    setEmergencyContactInfo(emergency_contact_data);
  }, [selector]);

  return <></>;
}
export default DTOEmergencyContact;
